import { FC } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 6
    }
});

export const NoteDetailTitle: FC<{ title: string }> = ({ title }) => {
    const classes = useStyles();
    return <div className={classes.title}>{title}</div>;
};
